import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box, Typography } from '@mui/material';

const PinExchangeLayout = () => {
    return (
        <>
            <Box sx={{ display: 'flex', gap: 2, pb: 1 }}>
                <Typography variant="h6" gutterBottom>Zustell-PIN Verwaltung</Typography>
            </Box>
            <Outlet />
        </>
    );
};

export default PinExchangeLayout;
